export const getChildPhotoSource = (child) =>
  child?.profilePhoto || child?.photoURL || child?.avatarUrl || '';

